import { motion, useScroll, useSpring } from 'motion/react';
import { usePrefersReducedMotion } from '../effects/motionConfig';

export default function ScrollProgress() {
  const reduced = usePrefersReducedMotion();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 28, restDelta: 0.001 });

  if (reduced) return null;

  return (
    <motion.div
      className="scroll-progress"
      aria-hidden="true"
      style={{ scaleX, transformOrigin: '0% 50%' }}
    />
  );
}
